import { create } from "zustand";

/** One move shown to the operator inside the MoveConfirm dialog.
 *  Mirrors ``TableMove`` from the suggestion / explorer plan + the
 *  multi-move proposals returned by the agent envelope. Used for both
 *  staff create-with-moves flows (sourced from
 *  ``GroupSuggestion.requires_moves``) and the explorer apply panel. */
export interface MoveConfirmEntry {
  reservation_id: string;
  guest_name: string;
  pax: number;
  from_table_names: string[];
  to_table_names: string[];
}

export interface MoveConfirmContext {
  moves: MoveConfirmEntry[];
  /** Display purpose: "create" → "para crear esta reserva";
   *  "edit" → "para guardar esta reserva"; "seat" → "para sentar a
   *  esta reserva"; "explorer" → "para aplicar este plan". */
  intent: "create" | "edit" | "seat" | "explorer";
}

interface Pending {
  context: MoveConfirmContext;
  resolve: (confirm: boolean) => void;
}

interface State {
  pending: Pending | null;
  open: (context: MoveConfirmContext) => Promise<boolean>;
  close: (confirm: boolean) => void;
}

export const useMoveConfirmStore = create<State>((set, get) => ({
  pending: null,
  open: (context) =>
    new Promise<boolean>((resolve) => {
      set({ pending: { context, resolve } });
    }),
  close: (confirm) => {
    const { pending } = get();
    if (pending) {
      pending.resolve(confirm);
      set({ pending: null });
    }
  },
}));
